import { useEffect } from "react";
import { comnUtils, comnEnvs } from "@/comn/utils";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { Page, Group, Layout, Button } from "@/comn/components";
import {
    useForm,
    useFetch,
    useToast,
    usePopup,
    useTheme,
    useStore,
    useGrid,
    useModal,
    useResource,
} from "@/comn/hooks";
import { BASE, APIS, SF_ORG_DEPT_M_SRCH, SG_ORG_DEPT_M } from "./services/OsciComnPpupService";

export const OrgDeptMList = (props: any) => {
    useResource({
        defaultSchema: [{ area: "comnCd", comnCd: "OSC0088" }],
    });

    const pgeUid = "orgDeptMLst";
    const { t } = useTranslation();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const toast = useToast();
    const modal = useModal();
    const { close, postMessage, getParams } = usePopup();
    const params = getParams(); /* * */
    const { theme } = useTheme();

    console.log("params?.orgCd ", params);

    const form = {
        orgDeptMSrch: useForm({
            defaultSchema: SF_ORG_DEPT_M_SRCH,
            defaultValues: { ...pgeStore?.form, orgCd: params?.orgCd || "" } || {},
        }),
    };

    const grid = {
        orgDeptMLst: useGrid({
            defaultSchema: SG_ORG_DEPT_M,
        }),
    };

    const fetch = {
        getOrgDeptMLst: useFetch({
            api: () => {
                return APIS.getOrgDept(form.orgDeptMSrch.getValues());
            },
            enabled: comnUtils.isEmpty(form.orgDeptMSrch.errors) && form.orgDeptMSrch.isSubmitted,
            onSuccess: (data) => {
                console.log("data ", data);

                setStore(pgeUid, {
                    form: form.orgDeptMSrch.getValues(),
                });
            },
        }),
    };

    const handler = {
        click_Btn_Srch: () => {
            form.orgDeptMSrch.handleSubmit(
                () => {
                    //grid.orgDeptMLst.setPage(0);
                    fetch.getOrgDeptMLst.fetch(0);
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" });
                },
            )();
        },
        /* * */
        click_Btn_Apply: () => {
            const list: any[] = grid.orgDeptMLst.getChecked() || [];
            if (comnUtils.isEmpty(list)) {
                modal.openModal({ content: "msg.osc.00084" });
                return;
            }

            postMessage({ data: list });
            close();
        },
    };

    const render = {
        grid_OrgDeptMLst: {
            cell: {
                deptNm: (props: any) => {
                    const { binding, rowValues, value } = props;
                    console.log("rowValues ", rowValues);
                    let pad = rowValues.lv - 1;
                    return (
                        <>
                            {<span style={{ marginRight: `${pad * 10}px` }}></span>}
                            <a
                                href="#!"
                                onClick={() => {
                                    if (!comnUtils.isPopup()) return;

                                    postMessage({
                                        code: rowValues.deptCd,
                                        label: rowValues.deptNm,
                                        desc: rowValues.deptDesc,
                                    });
                                    close();
                                }}
                            >
                                {value}
                            </a>
                        </>
                    );
                },
            },
        },
    };

    useEffect(() => {
        if (params?.comnCd) {
            form.orgDeptMSrch.setSchema("comnCd", { readOnly: true });
        }
        handler.click_Btn_Srch();
        /* * */
        if (params?.multiple === true) {
            grid.orgDeptMLst.setOption("checkbox", true);
        }
    }, []);

    return (
        <Page
            id={pgeUid}
            title={t("T_ORG_DEPT_CD_LST")}
            description={t("T_ORG_DEPT_CD_LST")}
            navigation={{
                base: comnEnvs.base,
                nodes: [...BASE.nodes, { label: "T_ORG_DEPT_CD_LST" }],
            }}
        >
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            {/* <Group.Control {...form.orgDeptMSrch.schema.orgNm}></Group.Control> */}
                            <Group.Control {...form.orgDeptMSrch.schema.deptNm}></Group.Control>
                        </Group.Row>
                    </Group.Section>
                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                onClick={() => {
                                    form.orgDeptMSrch.reset();
                                    handler.click_Btn_Srch();
                                }}
                            >
                                {t("B_RESET")}
                            </Button>
                        </Layout.Left>
                        <Layout.Right>
                            <Button
                                onClick={() => {
                                    handler.click_Btn_Srch();
                                }}
                            >
                                {t("B_SRCH")}
                            </Button>
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Group.Section>
                        {/* * */}
                        {params?.multiple === true && (
                            <Layout>
                                <Layout.Right>
                                    <Button
                                        role="apply"
                                        onClick={() => {
                                            handler.click_Btn_Apply();
                                        }}
                                    ></Button>
                                </Layout.Right>
                            </Layout>
                        )}
                        <Grid
                            {...grid.orgDeptMLst.grid}
                            data={fetch.getOrgDeptMLst.data?.orgDeptList}
                            render={render.grid_OrgDeptMLst}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
